
export default [
  {
    path: '',
    component: () => import('@/views/changeProposal/index.vue'),
    name: 'WhitelistChangeProposal',
    meta: { title: 'Whitelist Change Proposal', icon: 'tn-daiban', noCache: true, affix: true },
  }
]
